import section from "@assets/icons/miner_section.svg";
import origEdit from "@assets/redesign/icons/inputEdit.svg";
import delete_icon from "@assets/redesign/icons/trash.svg";
import wlpEdit from "@components/WLP202603/assets/redesign/icons/inputEdit.svg";
import Icon from "@components/global/new/Icon/Icon";
import NumberOfColumn from "@components/global/new/NumberOfColumn/NumberOfColumn";
import mainLocationsStore from "@mobx/store/locations";
import rackTemplatesStore from "@mobx/store/locations/rackTemplate";
import { IRackTemplate, RACK_SECTION_TYPE3 } from "@mobx/store/locations/types";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { makeGrid } from "@utils/makeGrid";
import { makeNotifs } from "@utils/makeNotifs";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { WLP202603 } from "../../../config";
import styles from "./RackTemplate.module.scss";

const edit = WLP202603 ? wlpEdit : origEdit;

export interface IRackTemplateProps {
  readonly rack: IRackTemplate;
}

const useControl = (
  props: IRackTemplateProps
) => {
  const buildingStore = mainLocationsStore.activeLocation?.activeBuilding;
  const { onSuccess } = useGlobalNotifs();
  const { ok } = makeNotifs();
  const [x, y] = props.rack.rack_type;
  const sectionSum = useMemo(() => x * y, [x, y]);

  const onEdit = () => {
    rackTemplatesStore.showRackModalForEdit(props.rack);
  };
  
  const onDelete = async () => {
    if (await rackTemplatesStore.delete(props.rack.id)) {
      onSuccess(ok.success);
    }
  };

  return {
    sectionSum,
    isFlipped: !!buildingStore?.isFlipped,

    onEdit,
    onDelete,
  };
};

const RackTemplate = observer((props: IRackTemplateProps) => {
  const { rack } = props;
  const control = useControl(props);
  const grid = makeGrid(rack.rack_type[0], "34px");
  return (
    <div className={cn(styles.wrapper)}>
      <h5
        className={styles.title}
      >{`[${rack.rack_type[1]}x${rack.rack_type[0]}]`}</h5>
      <div className={styles.sections} style={{ gridTemplateColumns: grid }}>
        {Array.from(new Array(control.sectionSum)).map((_, i) => (
          <NumberOfColumn
            rack_type={props.rack.rack_type}
            index={i}
            className={cn(styles.column_number, {
              [styles.show]: !control.isFlipped,
            })}
            key={i}
          >
            {rack.rack_items[i]?.pos === RACK_SECTION_TYPE3.EMPTY ||
            rack.rack_items[i] === undefined ? (
              <Icon src={section} className={styles.section_icon} noHover />
            ) : (
              <div className={styles.empty} key={i} />
            )}
          </NumberOfColumn>
        ))}
      </div>
      <div className={styles.btns}>
        <Icon src={edit} onClick={control.onEdit} />
        <Icon src={delete_icon} onClick={control.onDelete} />
      </div>
    </div>
  );
});

RackTemplate.displayName = "RackTemplate";

export default RackTemplate;
